import { EditorContent, useEditor } from '@tiptap/react'
import React, { useState } from 'react'

import extensions from 'jticxm-tiptap-extensions'

import CustomAlert from '../CustomAlert'
import EditorMenu from './EditorMenu'
import './editorStyles.css'

function getEmptyLinks(editor) {
  const emptyLinkHrefs = []
  editor.state.doc.descendants((node) => {
    if (node.isText) {
      const link = node.marks.find((m) => m.type.name === 'link')
      if (link && !node.text.trim()) {
        emptyLinkHrefs.push(link.attrs.href)
      }
    }
  })
  return [...new Set(emptyLinkHrefs)]
}

export default function EditorWrapper(props) {
  const { /*brand,*/ content, editable, toolbar, onUpdate, onEmptyLinksChange } = props
  const [emptyLinks, setEmptyLinks] = useState([])
  const editor = useEditor({
    content,
    editable,
    extensions,
    onUpdate: ({ editor }) => {
      const json = editor.getJSON()
      onUpdate && onUpdate(json)

      const emptyLinksFound = getEmptyLinks(editor)
      setEmptyLinks(emptyLinksFound)
      onEmptyLinksChange && onEmptyLinksChange(emptyLinksFound)
    },
  })

  if (!editor) return null

  return (
    <div>
      <EditorMenu editor={editor} settings={toolbar} />
      <EditorContent editor={editor} />
      {emptyLinks.length > 0 && (
        <CustomAlert type="error">
          Looks like you accidentally added links with no visible text, they appear as a single underline.
          Delete them and add text/space to fix. Affected links:
          <ul>
            {emptyLinks.map((href, i) => (
              <li key={i}>
                <a href style={{ color: 'inherit' }}>
                  {href}
                </a>
              </li>
            ))}
          </ul>
        </CustomAlert>
      )}
    </div>
  )
}
